import React from "react";
import PropTypes from "prop-types";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";

export function ChangeableGoodIcon({ isGood }) {
  if (isGood) {
    return (
      <div>
        <ThumbUpAltIcon color="primary" />
      </div>
    );
  } else {
    return (
      <div>
        <ThumbUpOffAltIcon color="primary" />
      </div>
    );
  }
}

ChangeableGoodIcon.propTypes = {
  isGood: PropTypes.bool,
};
